import { ark } from '@ark-ui/react';
import { styled } from '@terra/ui-styled-system';
import { textarea } from '@terra/ui-styled-system';
import type { ComponentProps } from '@terra/ui-styled-system';

export type TextareaProps = ComponentProps<typeof Textarea>;
export const Textarea = styled(ark.textarea, textarea);
